import { useEffect, useState } from 'react'
import { trainingOptionsStore } from '../services/trainingOptionsStore'

export function useTrainingOptions() {
  const [options, setOptions] = useState(trainingOptionsStore.getAll())

  useEffect(
    () =>
      trainingOptionsStore.subscribe(() =>
        setOptions(trainingOptionsStore.getAll()),
      ),
    [],
  )

  return {
    options,
    addOption: trainingOptionsStore.add.bind(trainingOptionsStore),
  }
}
